<template>
    <form-template @submit="proceed">
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm">Phone Number</p>
        </div>
        <div class="col-span-4 md:col-span-3">
            <biller-input placeholder="Input Phone Number" v-model="data.data_phone_number" required>
                <template v-if="loadingTelco" v-slot:append>
                    <img src="@/assets/svg/load.svg" alt="loader" class="w-6" />
                </template>
            </biller-input>
        </div>
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm">Carrier Network</p>
        </div>
        <div class="col-span-4 md:col-span-3">
            <div class="grid grid-cols-4 gap-3 w-full">
                <template v-if="data_categories.length">
                    <div
                        class="col-span-2 md:col-span-1"
                        v-for="tel in data_categories.slice(0, 3)"
                        :key="tel.service_id"
                    >
                        <biller-radio
                            @select="
                                () => {
                                    selectedOther = {}
                                    selectedDataService = {}
                                    data.variation_code = ''
                                    data.service_id = tel.serviceID
                                }
                            "
                            :value="tel.serviceID"
                            :active="data.service_id === tel.serviceID"
                            class="flex items-center justify-center"
                        >
                            <div class="flex items-center justify-center">
                                <img :src="tel.image" class="mx-auto pr-3 w-10" />
                                <p
                                    :class="
                                        `text-sm ${data.service_id === tel.serviceID ? 'text-purple' : 'text-grey-300'}`
                                    "
                                >
                                    {{ tel.name }}
                                </p>
                            </div>
                        </biller-radio>
                    </div>
                    <div class="col-span-2 md:col-span-1">
                        <template v-if="otherItems">
                            <others-drop-down
                                :otherItems="otherItems.slice(3)"
                                @selectedItem="selectOther"
                                :value="selectedOther.name || 'Others'"
                                :active="(selectedOther.serviceID || 'Others') === data.service_id"
                                text="Categories"
                            >
                                <template v-slot:selected>
                                    <template v-if="selectedOther.name !== undefined">
                                        <div class="flex items-center">
                                            <img
                                                :src="selectedOther.image"
                                                class="mx-auto pr-3 w-10"
                                                :alt="selectedOther.name"
                                            />
                                            <p class="text-xs text-grey-300">
                                                {{ selectedOther.name }}
                                            </p>
                                        </div>
                                    </template>
                                    <template v-else>
                                        Others
                                    </template>
                                </template>
                            </others-drop-down>
                        </template>
                    </div>
                </template>
                <template v-else>
                    <div class="col-span-2 md:col-span-1" v-for="index in 4" :key="index">
                        <telco-skeleton-loader />
                    </div>
                </template>
            </div>
        </div>
        <template v-if="data.service_id">
            <div class="col-span-4 md:col-span-1">
                <p class="text-smoke-dark text-sm">Data Volume</p>
            </div>
            <div class="col-span-4 md:col-span-3">
                <div class="grid grid-cols-4 gap-3 w-full">
                    <template v-if="data_services[data.service_id].length">
                        <div
                            class="col-span-2 md:col-span-1"
                            v-for="vol in data_services[data.service_id].slice(0, 3)"
                            :key="vol.variation_code"
                        >
                            <biller-radio
                                @select="
                                    () => {
                                        data.amount = parseInt(vol.variation_amount)
                                        data.variation_code = vol.variation_code
                                        selectedDataService = {}
                                    }
                                "
                                :value="vol.quantity"
                                :active="data.variation_code === vol.variation_code"
                            >
                                <div
                                    :class="
                                        `text-sm text-center mx-auto w-full ${
                                            data.variation_code === vol.variation_code ? 'text-purple' : 'text-grey-300'
                                        }`
                                    "
                                >
                                    <p class="text-xs">{{ vol.name }}</p>
                                </div>
                            </biller-radio>
                        </div>
                        <div class="col-span-2 md:col-span-1">
                            <template v-if="data_services">
                                <others-drop-down
                                    :otherItems="data_services[data.service_id].slice(3)"
                                    @selectedItem="selectOtherService"
                                    :value="selectedDataService.name || 'Others'"
                                    :active="(selectedDataService.variation_code || 'Others') === data.variation_code"
                                    text="Categories"
                                >
                                    <template v-slot:selected>
                                        <template v-if="selectedDataService.name !== undefined">
                                            <div class="flex items-center h-full overflow-auto">
                                                <p class="text-xs text-grey-300 ">
                                                    {{ selectedDataService.name }}
                                                </p>
                                            </div>
                                        </template>
                                        <template v-else>
                                            Others
                                        </template>
                                    </template>
                                </others-drop-down>
                            </template>
                        </div>
                    </template>
                </div>
            </div>
        </template>
    </form-template>
</template>

<script>
import telco from '@/mixins/telco'
import { formatAmount } from '@/util/formatAmount'
import OthersDropDown from '@/components/OthersDropdown'
import { mapActions } from 'vuex'

export default {
    name: 'DataForm',
    mixins: [telco],

    components: {
        OthersDropDown,
    },

    filters: {
        formatAmount: function(val) {
            return formatAmount(val)
        },
    },
    data() {
        return {
            selectedOther: {},
            selectedDataService: {},
            loadingTelco: false,
            selectedVol: '',
            otherItems: this.data_categories,
            data: {
                email: '',
                phone: '',
                country_id: '',
                service_id: '',
                data_phone_number: '',
                deposit_type: '',
                amount: '',
                variation_code: '',
            },
            vols: [
                {
                    quantity: '20GB',
                    price: '100',
                },
                {
                    quantity: '10GB',
                    price: '50',
                },
                {
                    quantity: '1GB',
                    price: '10',
                },
            ],
        }
    },
    methods: {
        ...mapActions('Message', {
            setMessage: 'SET_MESSAGE',
            setWarning: 'SET_WARNING',
        }),
        proceed(val) {
            const fullData = Object.assign(this.data, val)
            if (!this.data.service_id) {
                this.setMessage('Please select a Carrier network')
                this.setWarning('warning')
            } else if (!this.data.variation_code) {
                this.setMessage('Please select a data volume')
                this.setWarning('warning')
            } else {
                this.$emit('proceed', fullData)
            }
        },

        selectOther(val) {
            this.selectedOther = val
            this.data.service_id = val.serviceID
        },

        selectOtherService(val) {
            this.selectedDataService = val
            this.data.variation_code = val.variation_code
            this.data.amount = val.variation_amount
        },
    },

    watch: {
        data_categories: function(newVal) {
            this.$forceUpdate()
            this.otherItems = newVal
        },
    },
}
</script>

<style></style>
